import TreeNodeRenderer from './TreeNodeRenderer'
import NodeContentRenderer from './NodeContentRenderer'

const theme = {
  scaffoldBlockPxWidth: 45,
  treeNodeRenderer: TreeNodeRenderer,
  nodeContentRenderer: NodeContentRenderer
}

export default theme
